/** Localized compact relative time ("3h ago", "yesterday", "23d ago") via the platform Intl API. */
export function relativeTime(iso: string, locale: string): string {
  const diff = new Date(iso).getTime() - Date.now();
  const abs = Math.abs(diff);
  const rtf = new Intl.RelativeTimeFormat(locale || 'en', { numeric: 'auto', style: 'narrow' });
  const MIN = 60_000, HR = 3_600_000, DAY = 86_400_000;
  if (abs < MIN) return rtf.format(Math.round(diff / 1000), 'second');
  if (abs < HR) return rtf.format(Math.round(diff / MIN), 'minute');
  if (abs < DAY) return rtf.format(Math.round(diff / HR), 'hour');
  if (abs < 30 * DAY) return rtf.format(Math.round(diff / DAY), 'day');
  if (abs < 365 * DAY) return rtf.format(Math.round(diff / (30 * DAY)), 'month');
  return rtf.format(Math.round(diff / (365 * DAY)), 'year');
}
